export function composeOfferUrl({
  firmSlug,
  offerSlug,
  url,
  color,
}: {
  firmSlug: string
  offerSlug: string
  url: string
  color?: string
}) {
  if (offerSlug && firmSlug) {
    return color
      ? `/${firmSlug}/offres/${offerSlug}`
      : `/cabinets/${firmSlug}/offres/${offerSlug}`
  }
  return url
}
